import styled from '@emotion/styled';
import {fontSize, sizes} from 'patient-ping-remedy/packages/theme';

export const DatePickerWrapper = styled.div`
  & > div > div,
  .remedy-datepicker,
  .react-datepicker-wrapper {
    width: 100%;
  }

  .remedy-datepicker,
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    max-width: unset;
  }

  label {
    margin-bottom: ${sizes.xxSmall};
  }

  .iconButton > svg {
    font-size: ${fontSize.displaySmall};
  }
`;
